import { l } from '@manychat/manyui'

import { alert } from 'common/core'
import type { IThunkAction } from 'common/core/interfaces/actions'
import { ICON_PRODUCT_NAME } from 'common/fusion/constants'
import { getAccountOwnerName } from 'common/userRoles/selectors/userRolesSelectors'

export const showAgenticFlowUnavailableToast = (): IThunkAction => (_dispatch, getState) => {
  const ownerName = getAccountOwnerName(getState())

  const text = ownerName
    ? l.translate(
        '{ownerName} created this automation with {productName}. Ask them to make changes.',
        { ownerName, productName: ICON_PRODUCT_NAME },
      )
    : l.translate(
        'This automation was created with {productName}. Ask the account owner to make changes.',
        { productName: ICON_PRODUCT_NAME },
      )

  alert(text, 'info')
}
